import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useToast } from '../contexts/ToastContext';

interface SignupResponse {
  ok: boolean;
}

export function SignupPage() {
  const toast = useToast();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    businessName: '',
  });

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.email.trim() || !form.password) {
      toast.error('E-post och lösenord krävs');
      return;
    }
    if (form.password.length < 8) {
      toast.error('Lösenord måste vara minst 8 tecken');
      return;
    }
    if (form.password !== form.confirmPassword) {
      toast.error('Lösenorden matchar inte');
      return;
    }

    setLoading(true);
    try {
      await api.post<SignupResponse>('/auth/signup', {
        email: form.email.trim(),
        password: form.password,
        firstName: form.firstName.trim() || undefined,
        lastName: form.lastName.trim() || undefined,
        businessName: form.businessName.trim() || undefined,
      });
      toast.info('Konto skapat. Kontrollera din e-post och verifiera kontot innan inloggning.');
      navigate('/login', { replace: true });
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Kunde inte skapa konto');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-4">
      <div className="w-full max-w-sm">
        <div className="h-10 flex items-center justify-center mb-6">
          <img src="/logga.png" alt="ApisAI" className="h-10 w-auto max-w-full" />
        </div>
        <h1 className="text-lg font-semibold mb-3">Skapa konto</h1>
        <form onSubmit={onSubmit} className="space-y-3">
          <input
            type="email"
            placeholder="E-post *"
            className="w-full"
            value={form.email}
            onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
            autoComplete="email"
          />
          <input
            type="password"
            placeholder="Lösenord *"
            className="w-full"
            value={form.password}
            onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
            autoComplete="new-password"
          />
          <input
            type="password"
            placeholder="Bekräfta lösenord *"
            className="w-full"
            value={form.confirmPassword}
            onChange={(e) => setForm((f) => ({ ...f, confirmPassword: e.target.value }))}
            autoComplete="new-password"
          />
          <input
            type="text"
            placeholder="Förnamn"
            className="w-full"
            value={form.firstName}
            onChange={(e) => setForm((f) => ({ ...f, firstName: e.target.value }))}
          />
          <input
            type="text"
            placeholder="Efternamn"
            className="w-full"
            value={form.lastName}
            onChange={(e) => setForm((f) => ({ ...f, lastName: e.target.value }))}
          />
          <input
            type="text"
            placeholder="Företagsnamn"
            className="w-full"
            value={form.businessName}
            onChange={(e) => setForm((f) => ({ ...f, businessName: e.target.value }))}
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full py-1.5 px-3 bg-primary text-white rounded hover:bg-primary-hover disabled:opacity-50"
          >
            {loading ? 'Skapar konto...' : 'Skapa konto'}
          </button>
        </form>
        <p className="text-sm text-gray-600 mt-3">
          Har du redan konto?{' '}
          <Link to="/login" className="text-primary hover:underline">
            Logga in
          </Link>
        </p>
      </div>
    </div>
  );
}

